<template>
  <div id="pageLocalizazione">

    <div class="flex justify-between items-end">
      <div class="w-[fit-content] min-w-[200px] font-bold text-grey mb-1">
          <div class="text-[#1b1b1b] font-bold" style="font-size: 16px">{{title}}</div>
          <div v-if="subtitle" class="text-[#606060]">{{subtitle}}</div>
      </div>
      <div v-if="residence_number != 1" class="flex justify-end">
        <a class="!text-red" @click="removeResidenza">
          <!-- <v-icon small color="red">mdi-delete</v-icon> -->
          {{$t('Elimina')}}
        </a>
      </div>
    </div>

    <div>
      <div class="relative">
        <MapsAutocomplete @keypress.enter="$event.preventDefault()" @place-changed="setPlace" :placeholder="$t('Inserisci una posizione')"/>
        <div class="pac-target-input--set-mark flex items-center justify-center" @click.stop="show_map = !show_map">{{ show_map ? $t('Nascondi mappa') : $t('Mostra mappa') }}</div>
      </div>
      <!-- <div class="relative">
        <GmapAutocomplete @keypress.enter="$event.preventDefault()" @place_changed="setPlace" :placeholder="$t('Inserisci una posizione')"/>
        <div class="pac-target-input--set-mark flex items-center justify-center" @click.stop="show_map = !show_map">{{ show_map ? $t('Nascondi mappa') : $t('Mostra mappa') }}</div>
      </div> -->
      <div v-if="form.lat && form.lon" >
        <div v-if="show_map">
          <GmapMap
            v-if="center.lng != 9.189983"
            :center="center"
            :zoom="12"
            style="width: 100%; height: 400px; margin-top: 20px"
          >
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              @click="center = m.position"
            />
          </GmapMap>
        </div>
      </div>

      <div v-if="form.lat && form.lon && show_value" class="grid grid-cols-3 mt-3">

        <!-- address -->
        <div class="">
            <div class="campo">
              <div class="campo--label">{{$t('Indirizzo')}}:</div>
              <div class="campo--value">
                <p>{{form.indirizzo}}</p>
              </div>
            </div>
        </div>

        <!-- citta -->
        <div class="">
            <div class="campo">
              <div class="campo--label">{{$t('Città')}}:</div>
              <div class="campo--value">
                <p>{{form.citta}}</p>
              </div>
            </div>
        </div>

        <!-- cap -->
        <div class="">
            <div class="campo">
              <div class="campo--label">{{$t('Codice Postale')}}:</div>
              <div class="campo--value">
                <p>{{form.cap}}</p>
              </div>
            </div>
        </div>

        <!-- provincia -->
        <div class="">
            <div class="campo">
              <div class="campo--label">{{$t('Provincia')}}:</div>
              <div class="campo--value">
                <p>{{form.provincia}}</p>
              </div>
            </div>
        </div>

        <!-- regione -->
        <div class="">
            <div class="campo">
              <div class="campo--label">{{$t('Regione')}}:</div>
              <div class="campo--value">
                <p>{{form.regione}}</p>
              </div>
            </div>
        </div>

        <!-- nazione -->
        <div class="">
            <div class="campo">
              <div class="campo--label">{{$t('Paese')}}:</div>
              <div class="campo--value">
                <p>{{form.nazione}}</p>
              </div>
            </div>
        </div>

        <!-- Lat -->
        <div class="">
            <div class="campo">
              <div class="campo--label">{{$t('Latitudine')}}:</div>
              <div class="campo--value">
                <p>{{form.lat}}</p>
              </div>
            </div>
        </div>

        <!-- lon -->
        <div class="">
            <div class="campo">
              <div class="campo--label">{{$t('Longitudine')}}:</div>
              <div class="campo--value">
                <p>{{form.lon}}</p>
              </div>
            </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import MapsAutocomplete from '@/components/MapsAutocomplete.vue';
export default {
  components: {
    MapsAutocomplete,
  },
  props: {
      info: {},
      residence_number: {},
      title: {default: 'Citta'},
      subtitle: {},
      show_value: {default: true}
  },
  // props: ['info','residence_number'],
  data() {
    return {
      residenze: 1,
      show_map: false,
      center: { lat: 45.4642035, lon: 9.189983 },
      currentPlace: null,
      markers: [],
      form: {
        indirizzo: null,
        cap: null,
        citta: null,
        provincia: null,
        regione: null,
        nazione: null,
        lat: null,
        lon: null,
      }
    };
  },
  watch: {
    currentPlace() {

      let indirizzo = []

      this.form.indirizzo = null
      this.form.cap = null
      this.form.citta = null
      this.form.provincia = null
      this.form.regione = null
      this.form.nazione = null

      this.currentPlace.address_components.forEach(element => {

          let componentType = element.types[0]

          switch(componentType) {
            case "route":{
              indirizzo[0] = element.long_name
              break;
            }
            case "street_number":{
              indirizzo[1] = element.long_name
              break;
            }
            case "postal_code":{
              this.form.cap = element.long_name
              break;
            }
            case "country":{
              this.form.nazione = element.long_name
              break;
            }
            case "locality":{
              this.form.citta = element.long_name
              break;
            }
            case "administrative_area_level_1":{
              this.form.regione = element.long_name
              break;
            }
            case "administrative_area_level_2":{
              this.form.provincia = element.short_name
              break;
            }
          }
      });

      if(indirizzo[1]){
        this.form.indirizzo = indirizzo[0] + ", " + indirizzo[1]
      } else {
        this.form.indirizzo = indirizzo[0]
      }

      this.$emit("emitPosition", {
        info: this.form,
        n: this.residence_number
      });

    },
  },
  methods: {
    removeResidenza(){
      this.form.indirizzo = null
      this.form.cap = null
      this.form.citta = null
      this.form.provincia = null
      this.form.regione = null
      this.form.nazione = null
      this.form.lat = null
      this.form.lon = null

      this.$emit("deleteResidence", this.residence_number);
    }, 
    setProfileInformation(info_profile){
      this.form.nazione = info_profile.nazione ? info_profile.nazione : null
      this.form.citta = info_profile.citta ? info_profile.citta : null
      this.form.provincia = info_profile.provincia ? info_profile.provincia : null
      this.form.regione = info_profile.regione ? info_profile.regione : null
      this.form.indirizzo = info_profile.indirizzo ? info_profile.indirizzo : null
      this.form.cap = info_profile.cap ? info_profile.cap : null

        const marker = {
              lat: parseFloat(this.center.lat),
              lng: parseFloat(this.center.lon),
          };

      if(info_profile.lat && info_profile.lon){
          this.form.lat = info_profile.lat
          this.form.lon = info_profile.lon
          marker.lat = parseFloat(this.form.lat);
          marker.lng = parseFloat(this.form.lon);
      } 
        this.markers = []
        this.markers.push({ position: marker });
        this.center = marker;
    },

    setPlace(place) {
        if(place){
            this.currentPlace = place;
            this.addMarker()
        }
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.markers = []
        this.markers.push({ position: marker });
        this.center = marker;

        this.form.lat = marker.lat
        this.form.lon = marker.lng
      }
    },

  },
  created () {
    this.setProfileInformation(this.info)
  },
};
</script>

<style lang="scss" scope>
.pac-target-input {
    border: 1px solid black;
    padding: 10px;
    border-radius: 3px;
    width: 100%;

    &--set-mark{
      background: $primary;
      color: white;
      font-weight: 700;
      border-radius: 0 3px 3px 0;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      padding: 0 2rem;
    } 
}
.campo{
    width: 100%;
    display: flex;
    justify-content: space-between;

    &__100{
        display: block;
        .campo--value{
            margin-top: 10px;
        }
    }

    &--label{
        display: flex;
        align-items: center;
        font-family: 'Oswald';
        font-weight: 700;
        font-size: 16px;
        color: $primary;
        min-width: 150px;
        max-width: 200px;
        
        margin-bottom: 0;
    }
    &--value:not(.not){
        display: flex;
        align-items: end;
        flex-wrap: wrap;
        flex-grow: 1;
        font-size: 16px;
        p{
            font-size: 16px;

            margin-bottom: 0;
        }
    }

    &__valutazione{
        position: relative;
        &::after{
            content: '';
            display: block;
            height: 1px;
            background: $primary;
            position: absolute;
            left: 0;
            right: 0;
            bottom: -10px;
        }
    }
}
</style>